/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for an appointmentType
 * @export
 * @interface AppointmentTypeLightResponse
 */
export interface AppointmentTypeLightResponse {
    /**
     * Unique identifier of the appointment type
     * @type {string}
     * @memberof AppointmentTypeLightResponse
     */
    appointmentTypeId?: string;
    /**
     * Name of appointment type
     * @type {string}
     * @memberof AppointmentTypeLightResponse
     */
    name?: string;
    /**
     * Appointment types order
     * @type {number}
     * @memberof AppointmentTypeLightResponse
     */
    order?: number;
    /**
     * Note from the health pro for the patient
     * @type {string}
     * @memberof AppointmentTypeLightResponse
     */
    note?: string;
}

/**
 * Check if a given object implements the AppointmentTypeLightResponse interface.
 */
export function instanceOfAppointmentTypeLightResponse(value: object): value is AppointmentTypeLightResponse {
    return true;
}

export function AppointmentTypeLightResponseFromJSON(json: any): AppointmentTypeLightResponse {
    return AppointmentTypeLightResponseFromJSONTyped(json, false);
}

export function AppointmentTypeLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentTypeLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentTypeId': json['appointmentTypeId'] == null ? undefined : json['appointmentTypeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'order': json['order'] == null ? undefined : json['order'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AppointmentTypeLightResponseToJSON(json: any): AppointmentTypeLightResponse {
    return AppointmentTypeLightResponseToJSONTyped(json, false);
}

export function AppointmentTypeLightResponseToJSONTyped(value?: AppointmentTypeLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentTypeId': value['appointmentTypeId'],
        'name': value['name'],
        'order': value['order'],
        'note': value['note'],
    };
}

